
define('template!sdcBrowserCompatibilityModalClose',[''],function(template){return '<md-button type="button" class="sdc-tilt md-warn md-raised" ng-click="vm.close()">Continue Anyway</md-button>\r\n';});

